import { render, staticRenderFns } from "./MappingEmploymentModelWageTypes.vue?vue&type=template&id=4be2e364&scoped=true&"
import script from "./MappingEmploymentModelWageTypes.vue?vue&type=script&lang=js&"
export * from "./MappingEmploymentModelWageTypes.vue?vue&type=script&lang=js&"
import style0 from "./MappingEmploymentModelWageTypes.vue?vue&type=style&index=0&id=4be2e364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2e364",
  null
  
)

export default component.exports